var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseModule } from './../commons/BaseModule';
import Vue from 'vue';
var LocalRouterModule = (function (_super) {
    __extends(LocalRouterModule, _super);
    function LocalRouterModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredLocalRouters = [];
        return _this;
    }
    LocalRouterModule.prototype.preInstall = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            Vue.prototype.$setLocalRoute = _this.setLocalRoute.bind(_this);
            Vue.prototype.$goLocalRoute = _this.goLocalRoute.bind(_this);
            resolve(true);
        });
    };
    LocalRouterModule.prototype.finalizeInstall = function (options) {
        return new Promise(function (resolve, reject) {
            resolve(true);
        });
    };
    LocalRouterModule.prototype.registerLocalRouter = function (component, name) {
        this.registeredLocalRouters.push({
            component: component,
            name: name
        });
        console.log('registerLocalRouter', component, name, this.registeredLocalRouters);
    };
    LocalRouterModule.prototype.unregisterLocalRoute = function (component) {
        for (var i = 0; i < this.registeredLocalRouters.length; i++) {
            var localRouter = this.registeredLocalRouters[i];
            if (localRouter.component === component) {
                this.registeredLocalRouters.splice(i, 1);
                break;
            }
        }
        console.log('unregisterLocalRoute', component, this.registeredLocalRouters);
    };
    LocalRouterModule.prototype.setLocalRoute = function (routeName, routePath) {
        var localRouter = this.registeredLocalRouters.find(function (item) {
            if (item.name === routeName)
                return true;
        });
        if (localRouter) {
            localRouter.component.setPath(routePath);
        }
    };
    LocalRouterModule.prototype.goLocalRoute = function (routeName, value) {
        var localRouter = this.registeredLocalRouters.find(function (item) {
            if (item.name === routeName)
                return true;
        });
        if (localRouter) {
            localRouter.component.go(value);
        }
    };
    return LocalRouterModule;
}(BaseModule));
export default LocalRouterModule;



//////////////////
// WEBPACK FOOTER
// ./src/modules/local-router/index.ts
// module id = null
// module chunks = 